import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DialectGate } from './Gate';
import { LocalMessages } from './LocalMessages';
import { DialectSdk } from './Sdk';
export const DialectContext = React.createContext(null);
export const DialectContextProvider = ({ config, blockchainSdkFactory, gate, children }) => {
    return (_jsx(DialectContext.Provider, { value: null, children: _jsx(DialectSdk.Provider, { initialState: { config, blockchainSdkFactory }, children: _jsx(DialectGate.Provider, { initialState: gate, children: _jsx(LocalMessages.Provider, { children: children }) }) }) }));
};
//# sourceMappingURL=index.js.map